import { render, staticRenderFns } from "./KarmaRequestView.vue?vue&type=template&id=6fe4c202&scoped=true&"
import script from "./KarmaRequestView.vue?vue&type=script&lang=js&"
export * from "./KarmaRequestView.vue?vue&type=script&lang=js&"
import style0 from "./KarmaRequestView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaRequestView.vue?vue&type=style&index=1&id=6fe4c202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe4c202",
  null
  
)

export default component.exports